import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";

import 'common/css/master.css';
import SearchableMultiSelect from "./SearchableMultiSelectQp";
import { getStudentInterestListSvc, getStudentFavouritesListSvc, saveStudentsInterestsSvc, saveStudentsFavouritesSvc } from "./parentAssessmentSvc";


const Interests = (props) => {
    const { setLoader, setOpacity, schoolId, acdYrId, studentId, clsId } = props;

    const [lstInterest, setLstInterest] = useState([]);
    const [lstInterestId, setLstInterestId] = useState([]);
    const [favouriteColor, setFavouriteColor] = useState("");
    const [favouriteFlower, setFavouriteFlower] = useState("");
    const [favouriteFood, setFavouriteFood] = useState("");
    const [favouriteSport, setFavouriteSport] = useState("");
    const [favouriteAnimal, setFavouriteAnimal] = useState("");
    const [favouriteSubject, setFavouriteSubject] = useState("");
    const [key, setKey] = useState(0);


    useEffect(() => {
        // console.log("Interests called");
        if (schoolId, acdYrId, studentId, clsId) {
            getStudentInterestList(schoolId, acdYrId, studentId, clsId);
            getStudentFavouritesList(schoolId, acdYrId, studentId, clsId);
        }
    }, [schoolId, acdYrId, studentId, clsId, key]);

    const handleSelectInterests = (lstSelect) => {
        setLstInterestId(lstSelect);
    }


    const getStudentInterestList = (schoolId, acdYrId, studentId, clsId) => {
        // console.log("getStudentInterestList called");
        setLoader("block");
        setOpacity(0.5);
        getStudentInterestListSvc(schoolId, acdYrId, studentId, clsId, studentInterestListResponse);
    }

    const studentInterestListResponse = (data) => {
        // console.log("studentInterestListResponse called, data", data);
        if (data.status === "Success") {
            setLstInterest(data.lstInterest);
            const updatedLstInterestId = data.lstInterest
                .filter(interest => interest.interested)
                .map(interest => interest.interestId);
            // console.log("Updated Interest IDs:", updatedLstInterestId); 
            setLstInterestId(updatedLstInterestId);

        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getStudentFavouritesList = (schoolId, acdYrId, studentId, clsId) => {
        // console.log("getStudentFavouritesList called");
        setLoader("block");
        setOpacity(0.5);
        getStudentFavouritesListSvc(schoolId, acdYrId, studentId, clsId, studentFavouritesListResponse);
    }

    const studentFavouritesListResponse = (data) => {
        // console.log("studentFavouritesListResponse called, data", data);
        if (data.status === "Success") {
            setFavouriteColor(data.favouriteObj.color);
            setFavouriteFlower(data.favouriteObj.flower);
            setFavouriteFood(data.favouriteObj.food);
            setFavouriteSport(data.favouriteObj.sports);
            setFavouriteAnimal(data.favouriteObj.animal);
            setFavouriteSubject(data.favouriteObj.subject);
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }


    const saveStudentInterests = () => {
        // console.log("saveStudentInterests called");
        const lstInterestSelected = lstInterest.map((interest) => ({
            ...interest,
            interested: lstInterestId.includes(interest.interestId)
        }));
        // console.log("lstInterestSeleclstInterestSelected", lstInterestSelected);
        setLoader("block");
        setOpacity(0.5);
        saveStudentsInterestsSvc(schoolId, acdYrId, studentId, clsId, lstInterestSelected, saveStudentInterestsFavouritesResponse);
    }

    const saveStudentFavourites = () => {
        // console.log("saveStudentFavourites called");
        const objFavourite = {
            "color": favouriteColor,
            "flower": favouriteFlower,
            "food": favouriteFood,
            "sports": favouriteSport,
            "animal": favouriteAnimal,
            "subject": favouriteSubject
        }
        // console.log("objFavourite", objFavourite);
        setLoader("block");
        setOpacity(0.5);
        saveStudentsFavouritesSvc(schoolId, acdYrId, studentId, clsId, objFavourite, saveStudentInterestsFavouritesResponse);
    }

    const saveStudentInterestsFavouritesResponse = (data) => {
        // console.log("saveStudentInterestsFavouritesResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updatedKey();
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const updatedKey = () => {
        setKey(prevKey => prevKey + 1);
    }



    return (
        <div className="col-md-12 col-sm-12 col-xs-12 " style={{ border: "1px solid #ccc", borderRadius: "10px", padding: "20px 0" }}>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove" >
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12 " >
                                    I am interested in
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove" >
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                                    <SearchableMultiSelect
                                        lstItems={lstInterest}
                                        lstSelected={lstInterestId}
                                        handleSelectId={handleSelectInterests}
                                        valueField={"interestId"}
                                        labelField={"interest"}
                                        labelName={"Select Interests"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                        <div className="form-group col-md-9 col-sm-9 col-sm-10">
                            <button
                                className="pull-right btn btn-info"
                                onClick={(e) => saveStudentInterests(e)}
                                title="Save"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            {/* Favourite Color */}
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Color
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Color"
                                        placeholder="Favourite Color"
                                        value={favouriteColor}
                                        onChange={(e) => setFavouriteColor(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Favourite Flower */}
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Flower
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Flower"
                                        placeholder="Favourite Flower"
                                        value={favouriteFlower}
                                        onChange={(e) => setFavouriteFlower(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Favourite Food */}
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Food
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Food"
                                        placeholder="Favourite Food"
                                        value={favouriteFood}
                                        onChange={(e) => setFavouriteFood(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Favourite Sport */}
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Sport
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Sport"
                                        placeholder="Favourite Sport"
                                        value={favouriteSport}
                                        onChange={(e) => setFavouriteSport(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Favourite Animal */}
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Animal
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Animal"
                                        placeholder="Favourite Animal"
                                        value={favouriteAnimal}
                                        onChange={(e) => setFavouriteAnimal(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Favourite Subject */}
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                            <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                                    My Favourite Subject
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                    <input
                                        className="form-control"
                                        name="Favourite Subject"
                                        placeholder="Favourite Subject"
                                        value={favouriteSubject}
                                        onChange={(e) => setFavouriteSubject(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                    <div className="form-group col-md-9 col-sm-9 col-sm-10">
                        <button
                            className="pull-right btn btn-info"
                            onClick={(e) => saveStudentFavourites(e)}
                            title="Save"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Interests;